// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e69f7262","239":"268e02b5","453":"c25f80db","455":"054edaeb","867":"ef178c48"}[chunkId] + ".chunk.js";
};